import React from 'react';
import { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { PashaCardsContainer } from './styled';
import { ItemCard } from '../../ui/ItemCard';
import { FallbackView } from '../../FallbackView';
import { useBookmarks } from '../../../hooks/useBookmarks';
import { Item } from '../../../graphql/types';

export const FilterResult: React.FC<{
  pashaItems: Item[];
}> = ({ pashaItems }) => {
  const { t } = useTranslation();
  const { isBookmarked } = useBookmarks();

  return pashaItems.length ? (
    <PashaCardsContainer>
      {pashaItems.map(item => (
        <ItemCard
          key={item.id}
          {...item}
          stat="pasha-landing-item-card"
          deskCountItemsPerRows={5}
          inBookmarks={isBookmarked(item.id)}
          hideLabels
        />
      ))}
    </PashaCardsContainer>
  ) : (
    <FallbackView
      width={317}
      height={230}
      text={t('search.no_results.text')}
      icon="/static/images/new_ad/icons/icon-not-found.png"
      styles={css`
        width: 100%;
        background-color: inherit;
      `}
    />
  );
};
